import { render, staticRenderFns } from "./GasPageShell.vue?vue&type=template&id=412f74cb&scoped=true"
import script from "./GasPageShell.vue?vue&type=script&lang=js"
export * from "./GasPageShell.vue?vue&type=script&lang=js"
import style0 from "./GasPageShell.vue?vue&type=style&index=0&id=412f74cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412f74cb",
  null
  
)

export default component.exports